export default {"src":"/_next/static/media/pets.c14e1457.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};